import { render, staticRenderFns } from "./host-product-edit.vue?vue&type=template&id=05cfc40e&scoped=true&"
import script from "./host-product-edit.vue?vue&type=script&lang=js&"
export * from "./host-product-edit.vue?vue&type=script&lang=js&"
import style0 from "./host-product-edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./host-product-edit.vue?vue&type=style&index=1&id=05cfc40e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfc40e",
  null
  
)

export default component.exports